export default __webpack_public_path__ + "static/media/cif-ar.56aecb29.svg";